import {
  addUsersToNotificationGroupsEndPoint,
  createNotificationGroupsEndPoint,
  createNotificationUsersEndPoint,
  deleteNotificationGroupsEndPoint,
  fetchNotificationGroupsEndPoint,
  fetchNotificationUsersEndPoint,
  removeUsersToNotificationGroupsEndPoint,
  sendInviteEndPoint,
  updateNotificationGroupsEndPoint,
} from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import { getUsersFilteredBySiteAndRole } from "../../model/roleService";

export const fetchNotificationUser = async (activeSession) => {
  try {
    const response = await axiosInstance.post(
      fetchNotificationUsersEndPoint(),
      {
        accountName: activeSession.accountId,
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error fetching notification users:", error);
    throw error;
  }
};

export const addUserGroupsSubmit = async (payload, activeSession) => {
  const createEndPoint = createNotificationGroupsEndPoint();

  try {
    const createResponse = await axiosInstance.post(createEndPoint, payload);

    const createData = createResponse.data;
    console.log("Create Response data:", createData);

    return { success: true, data: createData };
  } catch (error) {
    console.error("Error:", error);
    return { success: false, message: error.message };
  }
};

export const createUser = async (userData, activeSession) => {
  const endPoint = createNotificationUsersEndPoint();

  const payload = {
    accountname: activeSession.accountId,
    user: userData,
  };

  try {
    const response = await axiosInstance.post(endPoint, payload);

    if (response.statusText === "OK") {
      console.log("User created successfully!");
      return true;
    } else {
      console.error("Failed to create user:", response.statusText);
      return false;
    }
  } catch (error) {
    console.error("Error creating user:", error);
    return false;
  }
};

export const inviteUser = async (
  userData,
  activeSession,
  setShowNotificationPopup,
  setShowModal
) => {
  let endPoint = sendInviteEndPoint;
  const { firstname, lastname, email, mdn, role, tagids } = userData;
  const cleanMdn = mdn.replace(/-/g, '');
  const modifiedMdn = cleanMdn.startsWith("+1") ? cleanMdn : cleanMdn.startsWith("1") ? `+${cleanMdn}` : `+1${cleanMdn}`;
  
  const payload = {
    user: {
      firstname,
      lastname,
      mdn: modifiedMdn,
      email,
    },
    roleid: role || '',
    siteids: tagids || [],
    billingaccountids: [userData.billingAccounts[0]] || [],  //[0] because api is throwing error if sending multiple in array
    invitationflow: "mobileapp",
  };  
    setShowModal((prev) => ({ ...prev, isLoading: true }));

  try {
    const userPostCallResponse = await axiosInstance.post(endPoint(), payload);
    const response = userPostCallResponse.data;

    setShowModal((prev) => ({ ...prev, isLoading: false }));
    return response;
  } catch (error) {
    setShowModal((prev) => ({ ...prev, isLoading: false }));
    console.error("Error inviting user:", error);
    throw error;
  }
};

export const reinviteUser = async (
  userData,
  activeSession,
  setShowNotificationPopup,
  setShowModal
) => {
  let endPoint = sendInviteEndPoint;
  const { firstname, lastname, email, mdn, role, tagids, oldinvitationid } = userData;
  const cleanMdn = mdn.replace(/-/g, '');
  const modifiedMdn = cleanMdn.startsWith("+1") ? cleanMdn : cleanMdn.startsWith("1") ? `+${cleanMdn}` : `+1${cleanMdn}`;

  const payload = {
    user: {
      firstname,
      lastname,
      mdn: modifiedMdn,
      email,
    },
    roleid: role || '',
    siteids: tagids || [],
    billingaccountids: [userData.billingAccounts[0]] || [],
    invitationflow: "mobileapp",
    oldinvitationid: oldinvitationid
  };
  setShowModal({ isLoading: true });

  try {
    const userPostCallResponse = await axiosInstance.post(endPoint(), payload);
    const response = userPostCallResponse.data;
    if (userPostCallResponse?.statusText === "OK") {
      setShowModal({ isOpen: false, isLoading: false });
    } else {
      setShowModal({ isOpen: false, isLoading: false });
    }
    return response;
  } catch (error) {
    setShowModal({ isOpen: false, isLoading: false });
    console.error("Error re-inviting user:", error);
    throw error;
  }
};

export const acceptInvite = async (payload, activeSession, url) => {
  const acceptInviteResponse =
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type" : "application/json",
          ...(activeSession && { Authorization: `Bearer ${activeSession}` })
        },
        body: JSON.stringify(payload)
      })
  return acceptInviteResponse;
};

export const getIndividualGroupDetail = async (userGroupID, activeSession) => {
  const endPoint = fetchNotificationGroupsEndPoint();
  const payload = {
    accountname: activeSession.accountId,
    filter: {
      $selection: {
        id: userGroupID,
      },
    },
  };
  try {
    const response = await axiosInstance.post(endPoint, payload);

    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error fetching group details:", error);
    throw error;
  }
};

export const addUsersToExistingGroup = async (
  userGroupID,
  userIds,
  activeSession,
  respDataEnabled = "true"
) => {
  const endPoint = addUsersToNotificationGroupsEndPoint();
  const payload = {
    accountname: activeSession.accountId,
    id: userGroupID,
    userids: userIds,
  };
  try {
    const response = await axiosInstance.post(endPoint, payload, {
      respDataEnabled: respDataEnabled,
    });

    return {
      status: response.status,
    };
  } catch (error) {
    console.error("Error adding users to the group:", error);
    throw error;
  }
};

export const removeUsersToExistingGroup = async (
  userGroupID,
  userIds,
  activeSession,
  respDataEnabled = "true"
) => {
  const endPoint = removeUsersToNotificationGroupsEndPoint();

  try {
    const response = await axiosInstance.post(
      endPoint,
      {
        accountname: activeSession.accountId,
        id: userGroupID,
        userids: userIds,
      },
      {
        respDataEnabled: respDataEnabled,
      }
    );

    return {
      status: response.status,
    };
  } catch (error) {
    console.error("Error removing users from the group:", error);
    throw error;
  }
};

export const updateUserGroupName = async (
  groupID,
  updatedName,
  activeSession
) => {
  const endPoint = updateNotificationGroupsEndPoint();
  const payload = {
    accountname: activeSession.accountId,
    id: groupID,
    group: {
      name: updatedName,
    },
  };
  try {
    const response = await axiosInstance.patch(endPoint, payload);
    return {
      status: response.status,
    };
  } catch (error) {
    console.error("Error adding users to the group:", error);
    throw error;
  }
};

export const deleteUserGroup = async (groupID, activeSession) => {
  const endPoint = deleteNotificationGroupsEndPoint();
  try {
    const response = await axiosInstance.delete(endPoint, {
      data: {
        accountname: activeSession.accountId,
        id: groupID,
        force: true,
      },
    });
    return response;
  } catch (error) {
    console.error("Error adding users to the group:", error);
    throw error;
  }
};

export const resetOrForgotPasswordApi = async (
  payload,
  activeSession,
  endPoint
) => {
  try {
    const response = 
    await fetch(endPoint, {
        method: "POST",
        headers: {
          "Content-Type" : "application/json",
          ...(activeSession && { Authorization: `Bearer ${activeSession}` })
        },
        body: JSON.stringify(payload)
      })
    return response;
  } catch (error) {
    console.error("Error in reset password:", error);
    throw error;
  }
};

export const fetchFilteredUsers = async (
  activeSession,
  roleids,
  siteids,
  dataList
) => {
  try {
    const apiResponse = await getUsersFilteredBySiteAndRole(
      activeSession,
      roleids,
      siteids
    );
    const dataToFilter = apiResponse
      ? apiResponse.map((user) => user?.email)
      : [];
    if (
      dataToFilter?.length === 0 &&
      (roleids?.length > 0 || siteids?.length > 0)
    ) {
      return [];
    }
    return dataList.filter((record) => dataToFilter.includes(record?.email));
  } catch (error) {
    console.error("Error fetching filtered users:", error);
    return null;
  }
};
